import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import LearningPathEditForm from './LearningPathEditForm';
import LearningPathEditDialogHeader from './LearningPathEditDialogHeader';

const LearningPathEditDialog = ({ show, onHide, id, isEdit, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: `${isEdit ? 'Edit' : 'Add'} Learning Path`,
    hide: onHide,
  });

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-edit-dialog"
    >
      <LearningPathEditDialogHeader modal={modal} />
      <LearningPathEditForm modal={modal} isEdit={isEdit} id={id} />
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(LearningPathEditDialog);
